export default function CardNumberItem({ label, value }: { label: any; value: number }) {
  return (
    <div className='text-center pt-2.5 pb-2 px-2'>
      <div className='text-base font-medium'>{value.toLocaleString()}</div>
      <div className='text-xs font-light mt-1'>{label}</div>
    </div>
  )
}
